/**
 * Global Imports
*/

import React, { useEffect, useContext, useState } from 'react';
import { Formik, Form } from 'formik';
import { useParams } from 'react-router-dom';

/**
 * Root Imports
*/

import { CssClassName } from '~/util/Css';
import { PageContext } from '~/components/PageProvider';
import { Box } from '~/components/Widget';
import { Input, Submit } from '~/components/Form';

/**
 * Local Imports
*/

import { UserContext } from '../../Providers/UserProvider';

/**
 * Exports
*/

/**
 * 
 */
export function ShowUser(props) {
  /** Contexts **/
  
  const provider = useContext(UserContext);
  const page = useContext(PageContext);
  const request = useParams();
  
  /** States **/
  
  const [ user, setUser ] = useState(null);
  const [ error, setError ] = useState(null);
  
  /** Side-Effects **/

  useEffect(() => {
    handleMount();
  }, []);
  
  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    provider.show(request)
      .then(response => setUser(response.data))
      .catch(error => setError(error.response.data))
    ;

    page.change({
      group: 'users',
      breadcrumbs: ['Users', 'Edit User']
    });
  };
  
  /**
   * 
   */
  const handleSubmit = (values, { setSubmitting }) => {
    provider.update(user, values)
      .finally(() => {
        setSubmitting(false);
      })
    ;
  };
  
  /** Renderers **/

  /**
   * 
   */
  const renderError = () => (
    <Box>
      <p>Error</p>
      <p>{ error.message }</p>
    </Box>
  );
  
  /**
   * 
   */
  const renderForm = ({ isSubmitting, ...formik }) => (
    <Form>
      <Input
        name='email'
        placeholder='Email Address'
        className='form-input'
        containerClassName='mb-4'
        formik={ formik }
      />

      <Submit
        className={
          CssClassName([
            'w-full btn btn-blue', isSubmitting && 'loading'
          ])
        }
        label='Save Changes'
        disabled={ isSubmitting }
      />
    </Form>
  );
  
  /**
   * 
   */
  const renderReady = () => (
    <div className='flex'>
      <Box className='w-2/6 mr-2'>
        <Formik initialValues={ user } onSubmit={ handleSubmit }>
          { renderForm }
        </Formik>
      </Box>
      <Box className='w-4/6 ml-2'>
        ...
      </Box>
    </div>
  );
  
  /** Output **/
  
  return error ? renderError() : user ? renderReady() : null;
}